import React, { PureComponent } from 'react';

import MenuItem from './MenuItem';

export default class LeftMenu extends PureComponent {
  render() {
    return (
      <aside className="menu">
        <p className="subtitle">
          <i className="mi mi-people-outline" style={{ marginRight: 8 }} />
          Utenti/Agenzie
        </p>
        <ul className="menu-list">
          <MenuItem title="Utenti" path="/admin/users">
            <MenuItem title="Lista" path="/admin/users" />
            <MenuItem title="Crea" path="/admin/users/new" />
          </MenuItem>
        </ul>
        <ul className="menu-list">
          <MenuItem title="Agenzie" path="/admin/agenzie">
            <MenuItem title="Lista" path="/admin/agenzie" />
            <MenuItem title="Crea" path="/admin/agenzie/new" />
          </MenuItem>
        </ul>
      </aside>
    );
  }
}

LeftMenu.displayName = 'LeftMenu';
